<template>
	<footer>
	  <div class="footer-main">
		版权所有
		<a
		  href="https://beian.miit.gov.cn/"
		  target="_blank"
		  rel="noopener noreferrer"
		>
		  陕ICP备2023002849号
		</a>
	  </div>
	</footer>
  </template>
  
  <script>
  export default {
	name: "footer",
	data() {
	  return {
	  };
	}
  };
  </script>
  
  <style scoped>
  .footer-main a {
	color: inherit; /* 保持链接的颜色与周围文本一致 */
	text-decoration: underline; /* 添加下划线以表明可点击 */
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Footer.vue